module.exports = __webpack_public_path__ + "static/media/A.36b1f187.png";